/**
 * @file pubStatus.ts
 * @description 产品状态的枚举及其对应标签的定义。
 *              包含所有可能的产品状态及其描述，便于在项目中统一管理和使用。
 *              提供方法以根据状态获取对应的标签。
 */
export enum ProductStatusEnum {
  ONLINE = 0,
  PRE_REGISTERED = 5,
  OFFLINE = 1,
  REMOVED = 6,
  PENDING = 2,
  CANCELED = 3,
  TEST = 4,
  EXTERNAL_AGENT = 7,
}

// 产品状态分类列表
export const pubStatusList = [
  {
    value: ProductStatusEnum.ONLINE,
    label: '在线',
    classTagName: 'nomal-tagbgc-green',
  },
  {
    value: ProductStatusEnum.PRE_REGISTERED,
    label: '预注册上线',
    classTagName: 'nomal-tagbgc-pink',
  },
  {
    value: ProductStatusEnum.OFFLINE,
    label: '下架',
    classTagName: 'nomal-tagbgc-red',
  },
  {
    value: ProductStatusEnum.REMOVED,
    label: '移除(被下架)',
    classTagName: 'nomal-tagbgc-grayblue',
  },
  {
    value: ProductStatusEnum.PENDING,
    label: '待发布',
    classTagName: 'nomal-tagbgc-yellow',
  },
  {
    value: ProductStatusEnum.CANCELED,
    label: '取消发布',
    classTagName: 'nomal-tagbgc-grey',
  },
  {
    value: ProductStatusEnum.TEST,
    label: '测试',
    classTagName: 'nomal-tagbgc-blue',
  },
  {
    value: ProductStatusEnum.EXTERNAL_AGENT,
    label: '外部代理',
    classTagName: 'nomal-tagbgc-orange',
  },
]

// 新增方法，通过id和key获取对应的属性值
export function getPubStatusProperty(id: ProductStatusEnum, key: 'label' | 'classTagName'): string {
  const statusItem = pubStatusList.find((item) => item.value === id)
  return statusItem ? statusItem[key] : '' // 如果状态不存在，返回默认值
}
